import { render, staticRenderFns } from "./resetPasswordCompleted.vue?vue&type=template&id=dd058a72&"
import script from "./resetPasswordCompleted.vue?vue&type=script&lang=ts&"
export * from "./resetPasswordCompleted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports